export default __webpack_public_path__ + "static/media/ap-sitemap.84ea5776.jpg";